import { useState, useEffect } from 'react';
import css from 'styled-jsx/css';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import paymentMethods from '../../../services/api/payment_methods';
import { colors } from '../Theme';

const paymentCardStyles = css`
  .payment-card {
    display: flex;
    padding: 20px 30px;
    flex-direction: column;
    border: 1px solid ${colors.ywgVeryLightPink};
    border-radius: 10px 10px 10px 10px;
    box-shadow: 0px 0px 4px 0px #c1bbbb;
  }

  .payment-card--active {
    border-color: ${colors.ywgPrimary};
    animation: active-card-shadow ease-in-out 1s 4;
  }

  @keyframes active-card-shadow {
    0% {
      box-shadow: none;
    }
    50% {
      box-shadow: 0px 0px 10px 0px ${colors.ywgPrimary};
    }
    100% {
      box-shadow: none;
    }
  }

  .card-line {
    display: flex;
  }

  .card-expiry {
    align-self: end;
    text-align: right;
  }

  .card-number {
    margin: 30px 0;
    font-size: 1.2rem;
    font-weight: 700;
  }

  .card-expiry-validity {
    font-size: 0.7rem;
  }

  .default-card-checkbox {
    display: inline;
    flex-grow: 1;
  }

  .default-card-checkbox__input {
    display: none;
  }

  .default-card-checkbox__label {
    color: grey;
    font-size: 0.7rem;
    cursor: pointer;
  }

  .default-card-checkbox__label::before {
    display: inline-block;
    margin-right: 6px;
    width: 12px;
    height: 12px;
    content: '';
    font-size: 0.8rem;
    text-align: center;
    border: 1px solid grey;
    vertical-align: middle;
    transition: border-radius 0.3s ease;
  }

  .default-card-checkbox__label--inprogress {
    color: ${colors.ywgPinkishOrangeStrong};
  }

  .default-card-checkbox__label--inprogress::before {
    border-color: ${colors.ywgPinkishOrangeStrong};
    border-radius: 50%;
    animation: default-card-checkbox-bgc ease-in-out 1.5s infinite;
  }

  @keyframes default-card-checkbox-bgc {
    0% {
      background-color: ${colors.ywgPrimary};
    }
    50% {
      background-color: ${colors.ywgPinkishOrangeStrong};
    }
    100% {
      background-color: ${colors.ywgPrimary};
    }
  }

  .default-card-checkbox__input:checked
    + .default-card-checkbox__label::before {
    background-color: ${colors.ywgPrimary};
    border-color: ${colors.ywgPrimary};
    content: '✓';
    color: white;
  }

  .default-card-checkbox__input:checked + .default-card-checkbox__label {
    color: ${colors.ywgPrimary};git
  }
`;

const DEFAULT_CARD_TEXT = 'Carte par défaut';
const DEFAULT_CARD_ERROR_TEXT =
  'Une erreur technique a empêché le changement de carte par défaut. Veuillez réessayer ou contactez le support.';

const PaymentCard = ({ card, checked, setDefaultCard }) => {
  const [newDefaultCardId, setNewDefaultCardId] = useState(false);
  useEffect(() => {
    if (card.action && checked && card.id !== newDefaultCardId) {
      setNewDefaultCardId(card.id);
    }
  }, [card.action, card.id, checked, newDefaultCardId]);
  const [defaultCardText, setDefaultCardText] = useState(DEFAULT_CARD_TEXT);
  const defaultCardId = `default-card-${card.id}`;
  const [defaultCardChanging, setDefaultCardChanging] = useState(false);
  const defaultCardChanged = async e => {
    if (
      checked ||
      (e.type === 'keypress' && !(e.key === 'Enter' || e.charCode === 32))
    ) {
      return false;
    }
    setDefaultCardChanging(true);
    setDefaultCardText('Sauvegarde en cours…');
    const changed = await paymentMethods.create({ id: card.id });
    setDefaultCardChanging(false);
    if (changed) {
      setDefaultCard({ ...card, default: false, action: false });
    } else {
      setDefaultCardText(DEFAULT_CARD_ERROR_TEXT);
    }
  };
  return (
    <div
      className={classnames('payment-card', {
        'payment-card--active':
          newDefaultCardId === card.id ||
          card.action === 'new' ||
          card.action === 'removed'
      })}
    >
      <div className="card-line">
        <div className="default-card-checkbox">
          <input
            type="checkbox"
            id={defaultCardId}
            onChange={defaultCardChanged}
            className="default-card-checkbox__input"
            checked={checked}
          />
          <label
            htmlFor={defaultCardId}
            className={classnames('default-card-checkbox__label', {
              'default-card-checkbox__label--inprogress': defaultCardChanging
            })}
            onKeyPress={defaultCardChanged}
            tabIndex="0"
          >
            {defaultCardText}
          </label>
        </div>

        <div className="card-brand">{card.brand}</div>
      </div>
      <div className="card-number">**** **** **** {card.last4}</div>
      <div className="card-expiry">
        <div className="card-expiry-validity">Durée de validité</div>
        {String(card.expMonth).padStart(2, '0')}/
        {String(card.expYear).substring(2)}
      </div>
      <style jsx>{paymentCardStyles}</style>
    </div>
  );
};

PaymentCard.propTypes = {
  card: PropTypes.object.isRequired
};

export default PaymentCard;
